export const enum TRIGGER_TYPE_ENUM {
  DIMENSION_HOVER = 'dimension-hover',
  ELEMENT_HIGHLIGHT = 'element-highlight',
  ELEMENT_SELECT = 'element-select',
  ELEMENT_ACTIVE = 'element-active'
}
